const ACTIONS = {
  SAVE: "SAVE",
  GET: "GET",
  DELETE: "DELETE",
};

export { ACTIONS };
